import { render, staticRenderFns } from "./businessAreaDetail.vue?vue&type=template&id=04b27c9e&scoped=true&"
import script from "./businessAreaDetail.vue?vue&type=script&lang=js&"
export * from "./businessAreaDetail.vue?vue&type=script&lang=js&"
import style0 from "./businessAreaDetail.vue?vue&type=style&index=0&id=04b27c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b27c9e",
  null
  
)

export default component.exports